import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useCart } from '../context/CartContext.tsx';
import {
  Button, TextField, MenuItem, Select, Box, InputLabel, FormControl,
  CircularProgress, Typography, Modal
} from "@mui/material";

const printfulTeeImage = "https://files.cdn.printful.com/files/b89/b899c3824e2130793dd74c0d3dbe918d_preview.png";



const CustomProductDesigner = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart, cartItems } = useCart();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState("");
  const [termsOpen, setTermsOpen] = useState(false);

  const [isZoomed, setIsZoomed] = useState(false);
  const [backgroundPos, setBackgroundPos] = useState("0% 0%");
  const imgRef = useRef(null);

  const calculatePriceWithVAT = (price) => {
    const priceNumber = parseFloat(price);
    return Math.round(priceNumber * 1.25);
  };

  const backendUrl = window.location.hostname === "localhost"
    ? "http://localhost:5001"
    : "https://own-project.onrender.com";

  useEffect(() => {
    let isMounted = true;

    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/printful-products/${id}`);
        if (isMounted && response.data) {
          setProduct(response.data);

          if (response.data.variants?.length > 0) {
            const uniqueColors = [...new Set(response.data.variants.map(v => v.color))];
            setSelectedColor(uniqueColors[0]);

            const firstVariant = response.data.variants.find(
              variant => variant.color === uniqueColors[0]
            );
            setSelectedSize(firstVariant.size);
            setSelectedPrice(calculatePriceWithVAT(firstVariant.price));
          }
        } else {
          setError("Produktdata saknas.");
        }
      } catch (err) {
        console.error(err);
        setError("Fel vid hämtning av produkt.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchProduct();
    return () => { isMounted = false; };
    
  }, [id, backendUrl]);
  useEffect(() => {
  if (product?.variants?.length) {
    console.log("⚡ Variant statuser för produkt:", product.name);
    product.variants.forEach(v => {
      console.log(`Variant ${v.size} / ${v.color} out_of_stock: ${v.out_of_stock}`);
    });
  }
}, [product]);


  const handleSizeChange = (e) => {
    const size = e.target.value;
    setSelectedSize(size);
    const variant = product?.variants?.find(
      v => v.size === size && v.color === selectedColor
    );
    setSelectedPrice(calculatePriceWithVAT(variant?.price || ""));
  };

  const handleColorChange = (e) => {
    const color = e.target.value;
    setSelectedColor(color);
    const variant = product?.variants?.find(
      v => v.color === color && v.size === selectedSize
    );
    setSelectedPrice(calculatePriceWithVAT(variant?.price || ""));
  };

  const handleQuantityChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (!isNaN(val) && val > 0) setQuantity(val);
  };

  const getHighResImage = (file) => {
    if (!file?.thumbnail_url) return "/placeholder.jpg";
    return file.thumbnail_url.replace("_thumb.png", "_preview.png");
  };

  // ✅ Hämta alltid selectedVariant säkert
  const selectedVariant = product?.variants?.find(
    v => v.size === selectedSize && v.color === selectedColor
  );

  // ✅ Lagerstatus
  const isOutOfStock = Boolean(selectedVariant?.out_of_stock);

  const handleAddToCart = () => {
    if (!selectedVariant) return;

    if (isOutOfStock) {
      alert("Produkten är slut i lager");
      return;
    }

    let defaultDesign =
  selectedVariant.design_files?.find(f => f.type === "default") ||
  selectedVariant.design_files?.find(f => f.type === "front_large") ||
  selectedVariant.design_files?.find(f => f.type === "embroidery_front_large") ||
  null;

// Fallback
if (!defaultDesign || !defaultDesign.url || defaultDesign.url.includes("_thumb")) {
  const firstRealFile = selectedVariant.design_files?.find(
    f => f.type === "default" || f.type === "front"
  );
  if (firstRealFile) defaultDesign = firstRealFile;
}


  // Säkra preview
    const previewDesign = selectedVariant.design_files?.find(f => f.type === "preview") || defaultDesign;
    const thumbnailUrl = previewDesign?.thumbnail_url || "/placeholder.jpg";

    const designFileUrl = selectedVariant.designFileUrl || defaultDesign?.thumbnail_url || "/placeholder.jpg";
    const designPrintFileUrl = designFileUrl;

    const uniqueId = `${product.external_id || selectedVariant.variant_id}-${selectedVariant.size}-${selectedVariant.color}-${selectedVariant.price || "no-price"}`;

    const cartItem = {
      ...selectedVariant,
      name: product.name,
      variants: product.variants,
      thumbnail_url: thumbnailUrl,
      selectedSize: selectedVariant.size,
      selectedPrice: selectedVariant.price,
      selectedColor: selectedVariant.color,
      previewFile: previewDesign,
      quantity,
      uniqueId,
      designFileUrl,
      designPrintFileUrl,
      availableSizes: product.variants
        .filter(v => v.color === selectedVariant.color)
        .map(v => v.size),
    };

  console.log("🛒 Lägger till i varukorgen:", cartItem); // <-- här loggar vi objektet innan det skickas

    addToCart(cartItem);

    const updatedCart = [...cartItems, cartItem];
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  console.log("💾 Uppdaterad localStorage:", updatedCart); // <-- här loggar vi hela localStorage-arrayen
  };

  const handleMouseMove = (e) => {
    if (!imgRef.current || !isZoomed) return;
    const { left, top, width, height } = imgRef.current.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setBackgroundPos(`${x}% ${y}%`);
  };

  const handleMouseLeave = () => setIsZoomed(false);
  const handleMouseEnter = () => !isZoomed && setBackgroundPos("50% 50%");
  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
    if (!isZoomed) setBackgroundPos("50% 50%");
  };
  const handleGoBack = () => navigate(-1);

  if (loading) return <CircularProgress style={{ display: "block", margin: "50px auto" }} />;
  if (error) return <Typography color="error" style={{ textAlign: "center", marginTop: "50px" }}>{error}</Typography>;
  if (!product) return null;

  const uniqueColors = [...new Set(product.variants.map(v => v.color))];
  const selectedVariantImage = selectedVariant?.variant_image_url;
  const previewFile = selectedVariant?.design_files?.find(f => f.type === "preview");
const displayedImage =
  product.name === "Unisex palestine t-shirt"
    ? printfulTeeImage
    : getHighResImage(previewFile) || selectedVariantImage || "/placeholder.jpg";


  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", minHeight: "100vh", backgroundColor: "#f7fafc", padding: "2rem", flexDirection: "column" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)", padding: "3rem", textAlign: "center", maxWidth: "700px", width: "100%", margin: "auto", display: "flex", flexDirection: "column" }}>
        <Typography variant="h5" component="h2" style={{ marginBottom: "1.5rem", color: "#2d3748" }}>{product.name}</Typography>

        <div
          ref={imgRef}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          onMouseEnter={handleMouseEnter}
          onClick={toggleZoom}
          style={{
            width: "100%",
            maxWidth: "700px",
            height: "auto",
            marginBottom: "1rem",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            backgroundImage: `url(${displayedImage})`,
            backgroundSize: isZoomed ? "200%" : "contain",
            backgroundPosition: backgroundPos,
            backgroundRepeat: "no-repeat",
            cursor: isZoomed ? "zoom-out" : "zoom-in",
            aspectRatio: "1 / 1",
            overflow: "hidden",
            transition: "background-size 0.3s ease, background-position 0.3s ease",
          }}
        >
          {!isZoomed && <img src={displayedImage} alt={`${product.name} preview`} style={{ width: "100%", borderRadius: "8px" }} loading="lazy" />}
        </div>

        {/* Färg & Storlek */}
        <FormControl fullWidth margin="normal">
          <InputLabel>Färg</InputLabel>
          <Select value={selectedColor} onChange={handleColorChange}>
            {uniqueColors.map(color => <MenuItem key={color} value={color}>{color}</MenuItem>)}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Storlek</InputLabel>
          <Select value={selectedSize} onChange={handleSizeChange}>
            {product.variants
              .filter(v => v.color === selectedColor)
              .map(v => (
                <MenuItem
                  key={v.size}
                  value={v.size}
                  disabled={Boolean(v.out_of_stock)}
                >
                  {v.size} {v.out_of_stock && "– Slut i lager"}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <TextField label="Antal" type="number" inputProps={{ min: 1 }} value={quantity} onChange={handleQuantityChange} fullWidth margin="normal" />

        <Typography variant="h6" style={{ marginTop: "1rem" }}>Pris: {selectedPrice} kr</Typography>
        <Typography variant="body2" color="textSecondary">(inkl. moms)</Typography>

        {/* Lagerstatus */}
        {selectedVariant && (
          <Typography
            variant="body1"
            style={{ marginTop: "1rem", color: isOutOfStock ? "red" : "green" }}
          >
            {isOutOfStock ? "Produkten är slut i lager" : "Finns i lager"}
          </Typography>
        )}

        <Box marginTop={2}>
          <Button
  variant="contained"
  disabled={isOutOfStock}
  onClick={handleAddToCart}
  fullWidth
  sx={{
    fontWeight: "bold",
    fontSize: "1rem",
    borderRadius: 2,
    paddingY: 1.2,
    background: "linear-gradient(90deg, #1e3a8a, #3b82f6)", // djupblå → klarblå
    color: "#fff",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    textTransform: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(90deg, #3b82f6, #1e3a8a)", // inverterad på hover
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "translateY(0px)",
      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    },
    "&.Mui-disabled": {
      background: "rgba(100, 100, 100, 0.4)",
      color: "#ccc",
      boxShadow: "none",
    },
  }}
>
  Lägg till i varukorgen
</Button>

        </Box>

        <Box mt={2}>
          <Link to="/cart" style={{ display: "inline-block", color: "#3182ce", textDecoration: "underline" }}>
            🛒 Gå till varukorgen {cartItems.length > 0 && <span style={{ fontWeight: "bold" }}>({cartItems.reduce((total, item) => total + item.quantity, 0)})</span>}
          </Link>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            marginTop: 4,
            padding: 2,
            border: "1px solid #ddd",
            borderRadius: 2,
            backgroundColor: "#fafafa",
            textAlign: "center",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          <Typography variant="body2" sx={{ color: "#000", lineHeight: 1.6 }}>
  Ej öppet köp eller ångerrätt. Läs{" "}
  <Button
    onClick={() => setTermsOpen(true)}
    sx={{
      padding: 0,
      minWidth: 0,
      textTransform: "none",
      fontSize: "0.9rem",
      color: "#1976d2",
      background: "transparent",
      "&:hover": { textDecoration: "underline", background: "transparent" }
    }}
  >
    Villkor
  </Button>{" "}
  för mer info.
</Typography>

        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 2 }}>
          <Button variant="text" onClick={handleGoBack} sx={{ alignSelf: "flex-start" }}>
            &larr; Tillbaka
          </Button>
        </Box>
      </div>
      <Modal open={termsOpen} onClose={() => setTermsOpen(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: { xs: 300, sm: 400 },
      bgcolor: "background.paper",
      borderRadius: 3,
      boxShadow: 24,
      p: 4,
      textAlign: "left",
    }}
  >
    <Typography
      variant="h6"
      sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
    >
      Villkor
    </Typography>

    <Typography
      variant="body1"
      sx={{
        fontSize: "1rem",
        fontWeight: 300,
        color: "#444",
        lineHeight: 1.9,
        backgroundColor: "#f9f9f9",
        padding: 2,
        borderRadius: 2,
        mb: 3,
      }}
    >
      Alla produkter trycks på beställning. Därför gäller inte öppet köp eller ångerrätt.
      <br /><br />
Vid skada, feltryck eller fel produkt kan ersättning beviljas om den bifogade bilden tydligt visar skadan eller den felaktiga varan.
      <br /><br />
      Bild skickas till <strong>WebShop02@outlook.com</strong>.
    </Typography>

    <Box sx={{ textAlign: "center" }}>
      <Button onClick={() => setTermsOpen(false)} variant="contained" color="primary">
        Stäng
      </Button>
    </Box>
  </Box>
</Modal>

    </div>
  );
};

export default CustomProductDesigner;
